var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 96,
    viewBox: "0 0 128 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4042_16254)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.868 28.3845C115.166 32.2824 122.861 42.4768 122.961 56.669C122.961 61.6662 123.061 70.0616 116.965 77.1577C110.769 84.2538 100.276 87.8518 92.0812 85.3532C86.9845 83.854 87.784 81.4553 81.1884 78.9567C80.0891 78.5569 67.3975 73.8595 59.103 79.9562C56.2049 82.055 56.8045 83.3543 53.9064 86.5525C53.3068 87.2521 43.6132 97.7464 30.2221 95.7475C19.8289 94.2483 11.1347 85.653 9.53573 76.8579C8.8362 72.96 9.53573 69.362 10.1353 66.3636C11.5344 59.3675 13.733 58.2681 15.5318 51.4718C16.1314 49.373 17.6304 43.3763 16.5311 36.1802C15.232 27.7849 11.7343 27.1852 11.7343 21.0886C11.6343 15.0919 14.9322 7.09626 22.2273 3.99796C28.1235 1.49934 35.3187 2.59873 39.5159 6.39664C41.4147 8.19565 41.4147 9.29505 42.9137 11.5938C47.9104 18.9897 57.504 20.8887 63.9997 22.2879C67.9971 23.0875 77.4908 24.9864 87.2843 21.4883C89.0832 20.8887 89.1831 20.5888 90.4822 20.289C98.1771 18.49 106.172 23.5872 111.868 28.3845Z",
    fill: "#C7B8FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M34.4205 22.787C33.0215 22.787 31.8223 21.6876 31.8223 20.1884C31.8223 18.6892 32.9215 17.5898 34.4205 17.5898C35.8196 17.5898 37.0188 18.6892 37.0188 20.1884C37.0188 21.6876 35.8196 22.787 34.4205 22.787ZM34.4205 18.6892C33.5211 18.6892 32.8216 19.3889 32.8216 20.2884C32.8216 21.1879 33.5211 21.8875 34.4205 21.8875C35.32 21.8875 36.0195 21.1879 36.0195 20.2884C36.0195 19.3889 35.32 18.6892 34.4205 18.6892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.761 69.2631C121.762 69.2631 120.163 67.564 120.163 65.5651C120.163 63.5662 121.762 61.8672 123.761 61.8672C125.759 61.8672 127.358 63.5662 127.358 65.5651C127.358 67.564 125.759 69.2631 123.761 69.2631ZM123.761 62.8666C122.262 62.8666 121.062 64.066 121.062 65.5651C121.062 67.0643 122.262 68.2637 123.761 68.2637C125.26 68.2637 126.459 67.0643 126.459 65.5651C126.459 64.066 125.26 62.8666 123.761 62.8666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.472 45.2772C107.173 45.2772 106.174 44.2777 106.174 42.9784C106.174 41.6791 107.173 40.6797 108.472 40.6797C109.771 40.6797 110.771 41.6791 110.771 42.9784C110.771 44.2777 109.771 45.2772 108.472 45.2772ZM108.472 41.6791C107.773 41.6791 107.173 42.2788 107.173 42.9784C107.173 43.678 107.773 44.2777 108.472 44.2777C109.172 44.2777 109.771 43.678 109.771 42.9784C109.771 42.2788 109.172 41.6791 108.472 41.6791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M4.14054 49.1719C3.7408 49.1719 3.34106 48.8721 3.34106 48.3724V42.9753C3.34106 42.5756 3.64087 42.1758 4.14054 42.1758C4.64021 42.1758 4.94001 42.4756 4.94001 42.9753V48.3724C4.94001 48.8721 4.54027 49.1719 4.14054 49.1719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.73855 46.4741H1.44205C1.04231 46.4741 0.642578 46.1743 0.642578 45.6746C0.642578 45.1748 0.94238 44.875 1.44205 44.875H6.73855C7.13829 44.875 7.53802 45.1748 7.53802 45.6746C7.53802 46.1743 7.23822 46.4741 6.73855 46.4741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M23.2284 89.0508C22.8287 89.0508 22.429 88.751 22.429 88.2513V82.8543C22.429 82.4545 22.7288 82.0547 23.2284 82.0547C23.7281 82.0547 24.0279 82.3545 24.0279 82.8543V88.2513C24.0279 88.751 23.6282 89.0508 23.2284 89.0508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M25.8264 86.353H20.5299C20.1302 86.353 19.7305 86.0532 19.7305 85.5535C19.7305 85.0537 20.0303 84.7539 20.5299 84.7539H25.8264C26.2262 84.7539 26.6259 85.0537 26.6259 85.5535C26.6259 86.0532 26.3261 86.353 25.8264 86.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M18.8295 5.49697C18.5297 5.49697 18.3298 5.29708 18.3298 4.99725V0.499725C18.3298 0.19989 18.5297 0 18.8295 0C19.1293 0 19.3292 0.19989 19.3292 0.499725V4.99725C19.3292 5.29708 19.0294 5.49697 18.8295 5.49697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20.9294 3.19867H16.6322C16.3324 3.19867 16.1326 2.99878 16.1326 2.69894C16.1326 2.39911 16.3324 2.19922 16.6322 2.19922H20.9294C21.2292 2.19922 21.4291 2.39911 21.4291 2.69894C21.4291 2.99878 21.2292 3.19867 20.9294 3.19867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M110.57 84.7548C110.27 84.7548 110.07 84.5549 110.07 84.2551V79.7575C110.07 79.4577 110.27 79.2578 110.57 79.2578C110.87 79.2578 111.07 79.4577 111.07 79.7575V84.2551C111.07 84.5549 110.87 84.7548 110.57 84.7548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M112.769 82.5581H108.471C108.172 82.5581 107.972 82.3582 107.972 82.0583C107.972 81.7585 108.172 81.5586 108.471 81.5586H112.769C113.068 81.5586 113.268 81.7585 113.268 82.0583C113.268 82.3582 113.068 82.5581 112.769 82.5581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.47 13.6908C107.871 13.6908 107.471 13.291 107.471 12.6913V4.99554C107.471 4.39587 107.871 3.99609 108.47 3.99609C109.07 3.99609 109.47 4.39587 109.47 4.99554V12.6913C109.47 13.191 108.97 13.6908 108.47 13.6908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M112.168 9.79187H104.773C104.173 9.79187 103.773 9.39209 103.773 8.79242C103.773 8.19275 104.173 7.79297 104.773 7.79297H112.168C112.768 7.79297 113.167 8.19275 113.167 8.79242C113.167 9.39209 112.768 9.79187 112.168 9.79187Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.37 74.0688L60.2738 77.95C60.7254 78.6576 61.348 79.24 62.0842 79.6434C62.8203 80.0468 63.6462 80.2583 64.4856 80.2583C65.3251 80.2583 66.151 80.0468 66.8871 79.6434C67.6232 79.24 68.2459 78.6576 68.6975 77.95L71.6013 74.0688C72.0392 73.4268 72.6192 72.8944 73.2963 72.5131C73.9734 72.1317 74.7293 71.9117 75.5053 71.8699C76.2812 71.8282 77.0564 71.966 77.7704 72.2725C78.4845 72.5791 79.1183 73.0462 79.6225 73.6375C84.74 79.1 88.9087 77.2887 88.9087 69.6412V37.24C88.9375 25.6537 86.235 22.75 75.3675 22.75H53.6325C42.765 22.75 40.0625 25.6537 40.0625 37.24V69.6125C40.0625 77.2887 44.26 79.0713 49.3488 73.6375C49.853 73.0462 50.4867 72.5791 51.2008 72.2725C51.9149 71.966 52.69 71.8282 53.466 71.8699C54.242 71.9117 54.9979 72.1317 55.675 72.5131C56.3521 72.8944 56.9321 73.4268 57.37 74.0688V74.0688Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.625 48.625H76",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.625 37.125H76",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 48.625H53.0259",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 37.125H53.0259",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4042_16254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoError);
export default __webpack_public_path__ + "static/media/icono-error.6d8ecead92a09b3aaf4cce6d6bd63ef8.svg";
export { ForwardRef as ReactComponent };